const state = {
  units: [],
  contractTypes: [],
}
const mutations = {
  setUnits(state, data) {
    state.units = data;
  },
  setContractTypes(state, data) {
    state.contractTypes = data;
  },
};


const actions = {}


export default {
  namespaced: true,
  state,
  mutations,
  actions
}
